import WorkflowTasksDetails from './WorkflowTasksDetails.Container';

export default WorkflowTasksDetails;
